export const AUTHORIZATION = "Authorization";
export const NEXT_LOCALE = "NEXT_LOCALE";
export const VWO_COMBINATION_COOKIE_1 = "_vis_opt_exp_";
export const VWO_COMBINATION_COOKIE_2 = "_combi";
export const PSP_COOKIE = "psp";
